import type { AuthoringLibraryLanguage } from "./authoringLibraryLanguages";
import type { AuthoringLibraryLabelKey } from "./authoringLibraryLabelKeys";
import de from "./de";
import en from "./en";
import es from "./es";
import fr from "./fr";
import hi from "./hi";
import hr from "./hr";
import ja from "./ja";
import pl from "./pl";
import ro from "./ro";
import sk from "./sk";
import sv from "./sv";
import uk from "./uk";

export type AuthoringLibraryResource = Partial<
  Record<AuthoringLibraryLabelKey, string>
>;

export const authoringLibraryResources: Record<
  AuthoringLibraryLanguage,
  AuthoringLibraryResource
> = {
  en,
  hi,
  es,
  ja,
  de,
  fr,
  hr,
  pl,
  ro,
  sk,
  sv,
  uk
};
